export default __webpack_public_path__ + "496fb07863bfa79722082322e9bf5f95.jpg";